document.addEventListener("DOMContentLoaded", function () {
  // 在页面中运行的 JavaScript 代码
  // 创建 IntersectionObserver 实例
  window.YGImageLoader = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        const newImg = new Image();
        newImg.onload = () => {
          img.src = newImg.src;
          img.removeAttribute('data-src');  // 如果只需要加载一次
          img.removeAttribute('srcset');  
          observer.unobserve(img);          // 停止观察该元素
        }
        newImg.src = img.getAttribute('data-src');
      }
    });
  }, { 
    rootMargin: "50px", // 预加载距离视口 50px 的图片
  });

  window._observer = new ResizeObserver(entries => {
    for (const entry of entries) {
      const height = entry.contentRect.height;
      this.dispatchEvent(
        new CustomEvent('height-change', {
          detail: { height },
          bubbles: true,
        })
      );
    }
  });

  window._observer.observe(document.body);

  window.YGVideoLoader = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
          // 获取内部的 template
          const template = entry.target.querySelector('template');
                
          // 将 template 的内容克隆为 DocumentFragment
          const fragment = template.content.cloneNode(true);
                
          // 先清空 yg-video 内部原有内容
          entry.target.innerHTML = '';
                
          // 将克隆的内容追加到 yg-video
          entry.target.appendChild(fragment);
      }
    });
  }, { 
    rootMargin: "200px", // 预加载距离视口 200px 的视频
  })
  class YGImage extends HTMLElement {
      constructor() {
          super()
          this.init()
      }
      init() {
          // 这里放置初始化逻辑
          this.loaderImg()
      }

      get images() {
        return this.querySelectorAll('img[data-src]')
      }

      loaderImg () {
          // 这里放置自定义逻辑
          this.images.forEach((img) => {
            window.YGImageLoader.observe(img)
          })
      }
  }
  if (!window.customElements.get('yg-image')) {
      window.customElements.define('yg-image', YGImage)
  }

  class YGVideo extends HTMLElement {
    constructor() {
        super()
        this.init()
    }
    init() {
        // 这里放置初始化逻辑
        this.loaderImg()
    }

    loaderImg () {
        // 这里放置自定义逻辑
        window.YGVideoLoader.observe(this)
    }
  }
  if (!window.customElements.get('yg-video')) {
      window.customElements.define('yg-video', YGVideo)
  }

  class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.clickClosePopup = this.clickClosePopup.bind(this);
      this.clickOpenPopup = this.clickOpenPopup.bind(this);
      this.$contentInner = null;
    }

    connectedCallback() {
      this.$contentInner = this.querySelector('.yg-popup-box-content-inner');
      this.addEventListener('click', this.clickClosePopup)
      document.addEventListener("YGPopup:open", this.clickOpenPopup)
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      document.removeEventListener('YGPopupBox:open', this.handleOpenEvent);
    }

    clickOpenPopup(event) {
      const { $popupTemplate, fn } = event.detail;
      this.openPopup($popupTemplate, fn);
    }

    clickClosePopup(e) {
      this.closePopup(e, () => {});
    }

    openPopup($popupTemplate, fn) {
      // popupTemplate：需要替换的元素
      if (!$popupTemplate || !this.$contentInner) return;
      this.$contentInner.innerHTML = $popupTemplate.innerHTML;
      document.body.style.overflow = 'hidden';
      this.style.display = 'flex';
      typeof fn === 'function' && fn();
    }
    
    closePopup(e, fn) {
      let closeClassName = ["yg-popup-box-close", "yg-popup-box"]
      if (closeClassName.some(className => e.target.classList.contains(className))) {
        this.style.display = 'none';
        this.$contentInner.innerHTML = '';
        document.body.style.overflow = 'auto';
        typeof fn === 'function' && fn();
      }
    }
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }

  class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.itemClick = this.itemClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.itemClick);
      this.hoverButton = new theme.HoverButton(this);
      this.hoverButton.load();
    }
  
    disconnectedCallback() {
      this.removeEventListener('click', this.itemClick);
    }

    itemClick() {
      let $popupTemplate = this.querySelector('template') || this.querySelector('.yg-popup-template');

      if ($popupTemplate) {
        document.dispatchEvent(new CustomEvent("YGPopup:open", {
          bubbles: true,
          detail: {
            $popupTemplate,
            fn: () => {}
          }
        }))
      }
    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }

  // 公共的写在上面↑↑↑↑↑↑↑↑↑↑

  // 组件的写在下面↓↓↓↓↓↓↓↓↓↓
  
  class YGSlideshow extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.initSwiper()
    }

    disconnectedCallback() {}

    initSwiper() {
      new Swiper(this, {
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 6000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        pagination: {
          el: '.swiper-pagination',
        }
      })
    }
  }
  if (!window.customElements.get('yg-slideshow')) {
    window.customElements.define('yg-slideshow', YGSlideshow);
  }

  class YGReviews extends HTMLElement {
      constructor() {
          super()
      }
      connectedCallback() {
        this.initMediaHeight()
        this.initSwiper()
      }

      initMediaHeight() {
        const container = this;
        container.style.setProperty('--media-height', `${this.querySelector('.yg-review-image').offsetHeight}px`)
      }

      initSwiper() {
        // 这里放置自定义逻辑
        new Swiper(this, {
          centeredSlides: true,
          slidesPerView: 'auto',
          loop: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          autoplay: this.getAttribute('data-autoplay') == 'true' ? {
            delay: Number(this.getAttribute('data-autoplay-delay')),
            stopOnLastSlide: false,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          } : false,
          autoplay: {
            delay: 6000,
            stopOnLastSlide: false,
            disableOnInteraction: true,
          },
          pagination: {
            el: '.swiper-pagination',
            clickable :true,
          },
          breakpoints: { 
            320: {  //当屏幕宽度大于等于320
              slidesPerView: 1,
              spaceBetween: 16
            },
            768: {  //当屏幕宽度大于等于320
              slidesPerView: 1.1,
              spaceBetween: 24
            },
            1280: {  //当屏幕宽度大于等于1280
              slidesPerView: 1.2,
              spaceBetween: 40
            }
          },
          on:{
            init: e => {
              if (e.passedParams.loop && e.slides.length < 4) {
                e.slides.forEach(slide => {
                  const clonedElement = slide.cloneNode(true);
                  e.slidesEl.appendChild(clonedElement);
                });
              }
            }
          }
        })
      }
  }
  if (!window.customElements.get('yg-reviews')) {
      window.customElements.define('yg-reviews', YGReviews)
  }
  class YGBrandList extends HTMLElement {
    constructor() {
        super()
    }
    connectedCallback() {
      this.initSwiper()
    }

    initSwiper() {
      // 这里放置自定义逻辑
      new Swiper(this, {
        initialSlide: 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: { 
          320: {  //当屏幕宽度大于等于320
            slidesPerView: 1.2,
            spaceBetween: 20
          },
          768: {  //当屏幕宽度大于等于768
            slidesPerView: 2.6,
            spaceBetween: 15
          },
          1280: {  //当屏幕宽度大于等于1280
            slidesPerView: 4.2,
            spaceBetween: 24
          }
        }
      })
    }
  }
  if (!window.customElements.get('yg-brand-list')) {
      window.customElements.define('yg-brand-list', YGBrandList)
  }  

  class YGAnchor extends HTMLElement {
      constructor() {
          super()
          this.itemClick = this.itemClick.bind(this);
          this._sectionList = null;
      }

      get sectionTop(){
        // 只在第一次获取时缓存 section 列表
        if (!this._sectionList) {
          this._sectionList = document.querySelectorAll('.main-content .shopify-section');
        }
      
        const sectionIndex = parseInt(this.getAttribute('data-section'), 10) - 1;
        const $section = this._sectionList[sectionIndex];

        if ($section) {
          return $section.offsetTop + 100;
        }

        return null;
      }

      connectedCallback() {
          this.addEventListener('click', this.itemClick);
      }

      disconnectedCallback() {
          this.removeEventListener('click', this.itemClick);
      }
      
      itemClick() {
        if (this.getAttribute('data-section-top') || this.sectionTop ) {
          window.scrollTo({
            top: this.getAttribute('data-section-top') || this.sectionTop,
            behavior: 'smooth',
          });
        }
      }
  }
  if (!window.customElements.get('yg-anchor')) {
      window.customElements.define('yg-anchor', YGAnchor)
  }

  class YGFScrollBanner extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      window.addEventListener('height-change', (e) => {
        this.initScrollAnimation();
      });
    }
  
    initScrollAnimation() {
      // 加载 gsap 和 ScrollTrigger
      if (!window.gsap || !window.ScrollTrigger) {
        const script1 = document.createElement('script');
        script1.src = 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/gsap.min.js';
        document.head.appendChild(script1);
  
        const script2 = document.createElement('script');
        script2.src = 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/ScrollTrigger.min.js';
        script2.onload = () => this.registerAnimations();
        document.head.appendChild(script2);
      } else {
        this.registerAnimations();
      }
    }
  
    registerAnimations() {
      gsap.registerPlugin(ScrollTrigger);
  
      const section = this;
      const image = section.querySelector('.scroll-banner');
      const title = section.querySelector('.title-wrapper');

      ScrollTrigger.getAll()
      .filter(trigger => trigger.trigger === section || section.contains(trigger.trigger))
      .forEach(trigger => trigger.kill());
  
      // 图像淡入
      if (image) {
        gsap.set(image, { opacity: 0 });
        gsap.to(image, {
          scrollTrigger: {
            trigger: section,
            start: 'top top+=50%',
            end: 'top top-=220px',
            scrub: true,
          },
          opacity: 1
        });
      }
  
      // 标题淡出
      if (title) {
        gsap.to(title, {
          scrollTrigger: {
            trigger: section,
            start: 'top top+=120px',
            end: 'top top-=220px',
            scrub: true,
          },
          opacity: 0
        });
      }
    }
  }
  
  if (!customElements.get('yg-scroll-banner')) {
    customElements.define('yg-scroll-banner', YGFScrollBanner);
  }

  class YGScrollSwitch extends HTMLElement {
      constructor() {
          super()
      }

      get indicatorSwiper (){
        let indicator = this.querySelector('.yg-switch-indicator');

        return new Swiper(indicator, {
          slidesPerView: 'auto',
          noSwiping: true,
          direction: 'vertical',
        })
      }

      get swiper() {
        let swiper = this.querySelector('.yg-scroll-switch');

        return new Swiper(swiper, {
          slidesPerView: 1,
          spaceBetween: 0,
          noSwiping: true,
          direction: 'vertical',
          thumbs: {
            swiper: this.indicatorSwiper,
          }
        })
      }

      get titleBox() {
        return this.querySelectorAll('.yg-title-box')
      }

      connectedCallback() {
        this.swiper
        setTimeout(() => {
          this.registerAnimations()
        }, 4000)
      }

      registerAnimations() {
        gsap.registerPlugin(ScrollTrigger);
      
        const totalSlides = this.swiper.slides.length;
      
        gsap.to(this, {
          scrollTrigger: {
            trigger: this.querySelector('.yg-section-main'),
            start: "top top",
            end: `+=${200 * totalSlides}`,
            pin: true,
            scrub: 1,
            snap: 1 / (totalSlides - 1),
            onUpdate: (self) => {
              const index = Math.round(self.progress * (totalSlides - 1));
              this.swiper.slideTo(index, 400);
              if (index == 0) {
                this.swiper.setTranslate(index)
              }

              this.titleBox.forEach((title, i) => {
                title.style.transform = `translateX(${(index) * -100}%)`
              })
            },
          }
        });
      }
  }
  if (!window.customElements.get('yg-scroll-switch')) {
      window.customElements.define('yg-scroll-switch', YGScrollSwitch)
  }

  class YGBgSwiper extends HTMLElement {
      constructor() {
          super()
      }

      get swiper() {
        let swiper = this.querySelector('.yg-bg-swiper');

        return new Swiper(swiper, {
          breakpoints: { 
            320: {  //当屏幕宽度大于等于320
              slidesPerView: 1.1,
              spaceBetween: 16
            },
            550: {  //当屏幕宽度大于等于320
              slidesPerView: 2.2,
              spaceBetween: 24
            },
            980: {  //当屏幕宽度大于等于1280
              slidesPerView: 2.8,
              spaceBetween: 24
            }
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        })
      }

      connectedCallback() {
        window.addEventListener('height-change', (e) => {
      
          // 在这里调用你希望触发的函数
          this.initScrollAnimation();
        });
        
        this.swiper
      }
    
      initScrollAnimation() {
        // 加载 gsap 和 ScrollTrigger
        if (!window.gsap || !window.ScrollTrigger) {
          const script1 = document.createElement('script');
          script1.src = 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/gsap.min.js';
          document.head.appendChild(script1);
    
          const script2 = document.createElement('script');
          script2.src = 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/ScrollTrigger.min.js';
          script2.onload = () => this.registerAnimations();
          document.head.appendChild(script2);
        } else {
          this.registerAnimations();
        }
      }
    
      registerAnimations() {
        gsap.registerPlugin(ScrollTrigger);
    
        const section = this;
        const image = section.querySelector('.yg-bg-image');
    
        // 图像淡入
        if (image) {
          gsap.set(image, { x: "100%" });
          gsap.to(image, {
            scrollTrigger: {
              trigger: section,
              start: 'top bottom',
              end: 'top top+=160px',
              scrub: true,
            },
            x: 0
          });
        }
  
      }
  }
  if (!window.customElements.get('yg-bg-swiper')) {
      window.customElements.define('yg-bg-swiper', YGBgSwiper)
  }

  class YGPartsList extends HTMLElement {
      constructor() {
          super()
          this.itemClick = this.itemClick.bind(this);

          this.$masterImages = null;
          this.$thumbnailImages = null
      }

      get masterImages() {
        if (!this.$masterImages) {
          this.$masterImages = this.querySelectorAll('.yg-master')
        }

        return this.$masterImages
      }

      get thumbnailImages() {
        if (!this.$thumbnailImages) {
          this.$thumbnailImages = this.querySelectorAll('.yg-thumbnail-item')
        }

        return this.$thumbnailImages
      }
      
      connectedCallback() {
        this.thumbnailImages.forEach((item, i) => {
          item.addEventListener('click',  (e) => this.itemClick(e, i));
        })
      }
      disconnectedCallback() {
        this.thumbnailImages.forEach((item, i) => {
          item.removeEventListener('click', (e) => this.itemClick(e, i));
        })
      }
      itemClick(e, i) {
        // 这里放置自定义逻辑
        this.thumbnailImages.forEach(($image) => {
          $image.classList.remove('active')
        })
        this.masterImages.forEach(($image) => {
          $image.classList.remove('active')
        })
        this.thumbnailImages[i].classList.add('active')
        this.masterImages[i].classList.add('active')
      }
  }
  if (!window.customElements.get('yg-parts-list')) {
      window.customElements.define('yg-parts-list', YGPartsList)
  }

  class YGScrollBer extends HTMLElement {
      constructor() {
          super()
          this.onScroll = this.onScroll.bind(this);

          this.scrollBer = this.querySelector('.scroll-thumb');
          this.scrollBox = this.scrollBer.parentElement.previousElementSibling;
      }
      connectedCallback() {
        this.scrollBox.addEventListener("scroll", this.onScroll);
        this.onScroll();
      }
      disconnectedCallback() {
        this.scrollBox.removeEventListener("scroll", this.onScroll);
      }

      onScroll() {
        const scrollTop = this.scrollBox.scrollTop;
        const scrollHeight = this.scrollBox.scrollHeight - this.scrollBox.clientHeight;
        const trackHeight = this.scrollBox.clientHeight;
        const thumbHeight = this.scrollBer.offsetHeight;
      
        const needsScroll = this.scrollBox.scrollHeight > trackHeight + 1;

        if (!needsScroll) {
          this.style.setProperty('--mask-start', '0px');
          this.style.setProperty('--mask-end', '0px');

          this.classList.add('no-scrollbar');
          return;
        }

        this.classList.remove('no-scrollbar');
        const moveRange = trackHeight - thumbHeight;
        const percent = scrollTop / scrollHeight;
      
        const translateY = moveRange * percent;
        this.scrollBer.style.transform = `translateY(${translateY}px)`;

        const isAtTop = scrollTop === 0;
        const isAtBottom = scrollTop + trackHeight >=  this.scrollBox.scrollHeight - 1; // 容错

        if (isAtTop) {
          this.style.setProperty('--mask-start', '0px');
          this.style.setProperty('--mask-end', '50px');
        } else if (isAtBottom) {
          this.style.setProperty('--mask-start', '50px');
          this.style.setProperty('--mask-end', '0px');
        } else {
          this.style.setProperty('--mask-start', '50px');
          this.style.setProperty('--mask-end', '50px');
        }
      }
  }
  if (!window.customElements.get('yg-scroll-ber')) {
      window.customElements.define('yg-scroll-ber', YGScrollBer)
  }

  class YGScrollVideo extends HTMLElement {
      constructor() {
          super()

          this.main = this.querySelector('.yg-video-box')
          this.image = this.querySelector('.yg-mask-image')
          this.video = this.querySelector('.yg-video')
      }

      connectedCallback() {
        setTimeout(() => {
          this.registerAnimations()
        }, 4800)
      }

      registerAnimations() {
        console.log(this.main)
        gsap.registerPlugin(ScrollTrigger);

        gsap.set(this.image, { scale: 1.4 });
        gsap.set(this.video, { scale: 1.4 });

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: this.main,
            start: "top top",
            end: "+=1500px",
            scrub: 1,
            pin: true,
          }
        });
        
        tl.to(this.image, { scale: 0.5 }, 0);
        tl.to(this.video, { scale: 0.5 }, 0);
      }
  }
  if (!window.customElements.get('yg-scroll-video')) {
      window.customElements.define('yg-scroll-video', YGScrollVideo)
  }

  class YGScrollVideo2 extends HTMLElement {
    constructor() {
        super()

        this.main = this.querySelector('.yg-video-box')
        this.video = this.querySelector('.yg-video')
    }

    connectedCallback() {
      setTimeout(() => {
        this.registerAnimations()
      }, 4000)
    }

    registerAnimations() {
      gsap.registerPlugin(ScrollTrigger);

        const video = this.video;
        const $firstText = this.querySelector('.yg-tips.first');
        const $lastText = this.querySelector('.yg-tips.last');

        const duration = Math.floor(video.duration);
        
        let obj = { currentTime: 0 };

        // 创建 ScrollTrigger 绑定视频播放
        gsap.to(obj, {
          currentTime: duration,
          ease: "none",
          scrollTrigger: {
            trigger: this.main,
            start: "top top",
            end: "+=3000px",
            scrub: true,
            pin: true,
            onUpdate: (self) => {
              if (obj.currentTime > duration) obj.currentTime = duration;

              video.currentTime = obj.currentTime;

              const currentTime = obj.currentTime;
              // 判断当前时间区间
              if (currentTime >= 2.6 && currentTime < 2.9) {
                // 计算区间内播放进度百分比
                $firstText.classList.add('active');
              } else {
                // 隐藏元素
                $firstText.classList.remove('active');
              }
              if (currentTime >= 3.5) {
                // 计算区间内播放进度百分比
                $lastText.classList.add('active');
              } else {
                // 隐藏元素
                $lastText.classList.remove('active');
              }
            }
          }
      })

      video.muted = true;
      video.play().then(() => {
        video.pause();
      });
    }
  }
  if (!window.customElements.get('yg-scroll-video-2')) {
      window.customElements.define('yg-scroll-video-2', YGScrollVideo2)
  }

  class YGScrollImage extends HTMLElement {
    constructor() {
        super()

        this.main = this.querySelector('.yg-video-box')
        this.image = this.querySelector('.yg-mask-image')
    }

    connectedCallback() {
      setTimeout(() => {
        this.registerAnimations()
      }, 4000)
    }

    registerAnimations() {
      gsap.registerPlugin(ScrollTrigger);

      gsap.set(this.image, { scale: 1});

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: this.main,
          start: "top top",
          end: "+=1500px",
          scrub: 1,
          pin: true,
        }
      });
      
      tl.to(this.image, {
        scale: 2.5,
        opacity: 1
      }, 0);
    
      // 第二段：scale 2.5 -> 5，opacity 1 -> 0
      tl.to(this.image, {
        scale: 5,
        opacity: 0
      });
    }
  }
  if (!window.customElements.get('yg-scroll-image')) {
      window.customElements.define('yg-scroll-image', YGScrollImage)
  }

  class YGHotVideo extends HTMLElement {
      constructor() {
          super()
      }
      connectedCallback() {
        this.initSwiper()
      }

      initSwiper() {
        // 这里放置自定义逻辑
        new Swiper(this, {
          centeredSlides: true,
          slidesPerView: 'auto',
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable :true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: { 
            320: {  //当屏幕宽度大于等于320
              slidesPerView: 1,
              spaceBetween: 16
            },
            768: {  //当屏幕宽度大于等于320
              slidesPerView: 1.1,
              spaceBetween: 24
            },
            1280: {  //当屏幕宽度大于等于1280
              slidesPerView: 1.3,
              spaceBetween: 40
            }
          },
          on:{
            init: e => {
              if (e.passedParams.loop && e.slides.length < 4) {
                e.slides.forEach(slide => {
                  const clonedElement = slide.cloneNode(true);
                  e.slidesEl.appendChild(clonedElement);
                });
              }
            }
          }
        })
      }
  }
  if (!window.customElements.get('yg-hot-video')) {
      window.customElements.define('yg-hot-video', YGHotVideo)
  }

  class YGVideoGuide extends HTMLElement {
      constructor() {
          super()
          this.$tabList = this.querySelectorAll('.yg-guide-tab')
          this.$tabContentList = this.querySelectorAll('.yg-guide-content')
          this.itemClick = this.itemClick.bind(this);
      }
      
      connectedCallback() {
        this.initSwiper()
        this.$tabList.forEach(($tab, i) => {
          $tab.addEventListener('click', (e)=>this.itemClick($tab, i));
        })
      }
      disconnectedCallback() {
        this.$tabList.forEach(($tab, i) => {
          $tab.removeEventListener('click', (e)=>this.itemClick($tab, i));
        })
      }

      initSwiper() {
        let $swiperList = this.querySelectorAll(".swiper")

        $swiperList.forEach((swiperItem) => {
          new Swiper(swiperItem, {
            scrollbar: {
              el: '.swiper-scrollbar'
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            breakpoints: {
              320: {  //当屏幕宽度大于等于320
                slidesPerView: 1.1,
                spaceBetween: 12
              },
              768: {  //当屏幕宽度大于等于320
                slidesPerView: 2,
                spaceBetween: 24
              },
              1280: {  //当屏幕宽度大于等于1280
                slidesPerView: 3,
                spaceBetween: 24
              }
            }
          })
        })
      }

      itemClick($tab, i) {
        if ($tab.classList.contains('active')) return

        this.$tabList.forEach(($tab) => {
          $tab.classList.remove('active')
        })
        this.$tabContentList.forEach(($tabContentList) => {
          $tabContentList.classList.remove('active')
        })
        this.$tabList[i].classList.add('active')
        this.$tabContentList[i].classList.add('active')
      }
  }
  if (!window.customElements.get('yg-video-guide')) {
      window.customElements.define('yg-video-guide', YGVideoGuide)
  }

  class YG3DList extends HTMLElement {
      constructor() {
          super()
      }
      connectedCallback() {
        this.initSwiper()
      }

      initSwiper() {
          new Swiper(this, {
            scrollbar: {
              el: '.swiper-scrollbar'
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            breakpoints: {
              320: {  //当屏幕宽度大于等于320
                slidesPerView: 1.1,
                spaceBetween: 12
              },
              768: {  //当屏幕宽度大于等于320
                slidesPerView: 2,
                spaceBetween: 24
              },
              1280: {  //当屏幕宽度大于等于1280
                slidesPerView: 3,
                spaceBetween: 24
              }
            }
          })
      }
  }
  if (!window.customElements.get('yg-3d-list')) {
      window.customElements.define('yg-3d-list', YG3DList)
  }

  class YGNavAnchor extends HTMLElement {
    constructor() {
      super();
      this.sections = [];
      this.anchors = [];
      this.anchorIndexes = [];
      this.currentActive = null;
      this._scrolling = false;
      this._onResize = this.updateSectionPositions.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
    }
  
    connectedCallback() {
      // 初始渲染时完全禁用，避免任何布局计算
      this.style.visibility = 'hidden';
      this.style.opacity = '0';
      
      this.anchors = Array.from(this.querySelectorAll('.yg-nav-anchor__item'));

      // 提取并排序 anchors
      this.anchorIndexes = this.anchors
        .map(anchor => parseInt(anchor.dataset.section))
        .sort((a, b) => a - b);

      // 初始化 section 引用（不设置编号，避免触发布局）
      this.rawSections = Array.from(document.querySelectorAll('.main-content .shopify-section'));
      
      // 标记为未初始化，避免在页面加载时调用 getBoundingClientRect()
      this._initialized = false;
      
      // 只在用户首次滚动时才初始化位置计算，避免影响页面加载时的布局
      const initOnFirstScroll = () => {
        if (this._initialized) return;
        this._initialized = true;
        
        // 设置 section 编号
        this.rawSections.forEach((section, i) => {
          if (!section.hasAttribute('data-section-number')) {
            section.setAttribute('data-section-number', i);
          }
        });
        
        // 初始化位置计算
        this.updateSectionPositions();
        
        // 显示组件
        this.style.visibility = '';
        this.style.opacity = '';
        this.classList.add('ready');
      };
      
      // 监听滚动事件（passive: true 避免阻塞）
      let scrollListener = null;
      scrollListener = () => {
        initOnFirstScroll();
        // 初始化后，移除这个一次性监听器，使用正常的 handleScroll
        window.removeEventListener('scroll', scrollListener);
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this._onResize);
        this.handleScroll();
      };
      
      window.addEventListener('scroll', scrollListener, { passive: true, once: true });
      
      // 如果页面已经滚动，立即初始化
      if (window.scrollY > 0) {
        initOnFirstScroll();
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this._onResize);
      }
    }
  
    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this._onResize);
    }
  
    updateSectionPositions() {
      // 只在已初始化时计算位置，避免在页面加载时触发强制同步布局
      if (!this._initialized) return;
      
      // 使用 requestAnimationFrame 批量计算，减少强制同步布局
      requestAnimationFrame(() => {
        this.sections = this.rawSections.map(el => ({
          el,
          index: parseInt(el.dataset.sectionNumber),
          top: el.getBoundingClientRect().top + window.scrollY
        }));
      });
    }

    handleScroll() {
      if (this._scrolling || !this._initialized) return;
      this._scrolling = true;

      // 使用 requestAnimationFrame 延迟计算，避免强制同步布局
      requestAnimationFrame(() => {
        let sections = this.rawSections.map(el => ({
          el,
          index: parseInt(el.dataset.sectionNumber),
          top: el.getBoundingClientRect().top + window.scrollY
        }));

        if (this.sections !== sections) {
          this.sections = sections;
        }

        requestAnimationFrame(() => {
          const scrollMiddle = window.scrollY + window.innerHeight / 2;
          let currentIndex = null;

          for (let section of this.sections) {
            const height = section.el.offsetHeight;
            if (scrollMiddle >= section.top && scrollMiddle < section.top + height) {
              currentIndex = section.index + 1;
              break;
            }
          }

          if (currentIndex === null) {
            this._scrolling = false;
            return;
          }

          // 区间匹配
          let anchorToHighlight = null;
          for (let i = 0; i < this.anchorIndexes.length - 1; i++) {
            const from = this.anchorIndexes[i];
            const to = this.anchorIndexes[i + 1];
            if (currentIndex >= from && currentIndex < to) {
              anchorToHighlight = from;
              break;
            }
          }

          if (currentIndex >= this.anchorIndexes[this.anchorIndexes.length - 1]) {
            anchorToHighlight = this.anchorIndexes[this.anchorIndexes.length - 1];
          }

          if (anchorToHighlight !== this.currentActive) {
            this.setActive(anchorToHighlight);
          }

          this._scrolling = false;
        });
      });
    }
  
    setActive(index) {
      this.anchors.forEach(anchor => {
        anchor.classList.toggle('active', parseInt(anchor.dataset.section) === index);
      });
      this.currentActive = index;
    }
  }
  
  if (!window.customElements.get('yg-nav-anchor')) {
    window.customElements.define('yg-nav-anchor', YGNavAnchor);
  }

  class YGCollectionTab extends HTMLElement {
    constructor() {
      super()
      this.$tabList = this.querySelectorAll('.yg-tab')
      this.$tabContentList = this.querySelectorAll('.yg-content')
      this.itemClick = this.itemClick.bind(this);
    }

    connectedCallback() {
      this.$tabList.forEach(($tab, i) => {
        $tab.addEventListener('click', (e)=>this.itemClick($tab, i));
      })
    }
    disconnectedCallback() {
      this.$tabList.forEach(($tab, i) => {
        $tab.removeEventListener('click', (e)=>this.itemClick($tab, i));
      })
    }

    itemClick($tab, i) {
      if ($tab.classList.contains('active')) return

      this.$tabList.forEach(($tab) => {
        $tab.classList.remove('active')
      })
      this.$tabContentList.forEach(($tabContentList) => {
        $tabContentList.classList.remove('active')
      })
      this.$tabList[i].classList.add('active')
      this.$tabContentList[i].classList.add('active')
    }
  }
  if (!window.customElements.get('yg-collection-tab')) {
      window.customElements.define('yg-collection-tab', YGCollectionTab)
  }

  class YGPullDown extends HTMLElement {
    constructor() {
        super()
        this.itemClick = this.itemClick.bind(this);
        this.height = this.getAttribute('data-height')
        this.$targetElement = this.previousElementSibling
    }
    connectedCallback() {
        this.isPull()
        this.addEventListener('click', this.itemClick);
    }
    disconnectedCallback() {
        this.removeEventListener('click', this.itemClick);
    }
    itemClick() {
      // 这里放置自定义逻辑
      if(!this.classList.contains('active')) {
        let height = 0;
        this.$targetElement.style.height = "auto"
        height = this.$targetElement.getBoundingClientRect().height
        this.$targetElement.style.height = this.height + 'px'
        this.$targetElement.getBoundingClientRect().height
        this.$targetElement.style.height = height + 'px'
        this.classList.add('active')
        this.$targetElement.classList.add('active')
      } else {
        this.$targetElement.style.height = this.height + 'px'
        this.classList.remove('active')
        this.$targetElement.classList.remove('active')
      }
    }
    isPull(){
      if (this.$targetElement.offsetHeight <= this.height) {
        this.remove()
      } else {
        this.$targetElement.classList.add('yg-pull-main')
        this.$targetElement.style.height = this.height + 'px'
      }
    }
  }
  if (!window.customElements.get('yg-pull-down')) {
      window.customElements.define('yg-pull-down', YGPullDown)
  } 

  class YGMegaMenuTab extends HTMLElement {
      constructor() {
          super()

          this.tabItems = this.querySelectorAll('.yg-mega-menu-item');
          this.contentItems = this.querySelectorAll('.yg-mega-menu-content');
          this.itemMouseenter = this.itemMouseenter.bind(this);
      }
      connectedCallback() {
        this.tabItems.forEach((item, i) => {
          item.addEventListener('mouseenter', () => this.itemMouseenter(item, i));
        })
      }
      disconnectedCallback() {
        this.tabItems.forEach(item => {
          item.removeEventListener('mouseenter', this.itemMouseenter);
        })
      }
      itemMouseenter(item, i) {
        this.tabItems.forEach(i => i.classList.remove('active'));
        this.contentItems.forEach(i => i.classList.remove('active'));
        item.classList.add('active');
        this.contentItems[i].classList.add('active');
      }
  }
  if (!window.customElements.get('yg-mega-menu-tab')) {
      window.customElements.define('yg-mega-menu-tab', YGMegaMenuTab)
  }

  class YGShopList extends HTMLElement {
    constructor() {
      super();
      this.targetType = this.targetType.bind(this);
      this.scrollLocation = this.scrollLocation.bind(this);
      this.typeList = this.querySelectorAll('.yg-shop-type');
      this.shopList = this.querySelectorAll('.yg-shop-item');
      this.shopAreaList = this.querySelectorAll('.yg-shop-area-content');
      this.shopAreaTabList = this.querySelectorAll('.yg-shop-area-list .yg-shop-area')
      this.selectCountryTitle = this.querySelector('.yg-select-country-title');
    }

    connectedCallback() {
        this.typeList.forEach((type) => {
            type.addEventListener('click', () => this.targetType(type));
        });

        this.shopAreaTabList.forEach((area) => {
            area.addEventListener('click', () => this.scrollLocation(area));
        })

        const listWrapper = this.querySelector('.yg-shop-list-wrapper')
        window.addEventListener('scroll', () => {
          
          if(listWrapper.getBoundingClientRect().top <= 0) {
            this.querySelector('.yg-shop-list-wrapper').classList.add('active');
          } else {
            this.querySelector('.yg-shop-list-wrapper').classList.remove('active');
          }
        });

        this.initMappySearch();
    }

    targetType(type) {
        if (type.classList.contains("active")) return;

        // 移除所有 active
        this.typeList.forEach((el) => el.classList.remove("active"));

        // 添加当前 active
        type.classList.add("active");

        let typeHandle = type.getAttribute('data-shop-type');

        if (typeHandle == 'all') {
          this.shopList.forEach((el) => {
            el.classList.remove('hidden')
          })
        } else {
          this.shopList.forEach((el) => {
            if (el.getAttribute('data-shop-type') == typeHandle) {
              el.classList.remove('hidden')
            } else {
              el.classList.add('hidden')
            }
          })
        }

        this.targetCount()
        this.labelClick(type)
    }

    targetCount() {
      let allNumber = 0;
      this.shopAreaList.forEach((el) => {
        let tab = this.querySelector(`.yg-shop-area[data-area="${el.getAttribute('data-area-content')}"]`)
        let count = el.querySelectorAll('.yg-shop-item:not(.hidden)').length
        el.querySelector('.yg-shop-count').innerHTML = `(${count})`
        tab.querySelector('.yg-shop-count').innerHTML = `(${count})`

        allNumber += count
      })

      this.querySelector('.yg-section-title .yg-shop-count').innerHTML = allNumber
    }

    scrollLocation(area) {
      let target = this.querySelector(`.yg-shop-area-content[data-area-content="${area.getAttribute('data-area')}"]`);
    
      const rect = target.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const offsetTop = rect.top + scrollTop;
    
      window.scrollTo({
        top: offsetTop - 300,
        behavior: 'smooth',
      });
    
      // 移除所有 active
      this.shopAreaTabList.forEach((el) => el.classList.remove("active"));
      // 添加当前 active
      area.classList.add("active");

      this.labelClick(area)
    }

    labelClick(item) {
      // 添加新的活动状态
      const parent = item.parentElement;
      if (parent && this.isScrollable(parent)) {
        const containerRect = parent.getBoundingClientRect();
        const targetRect = item.getBoundingClientRect();
        const scrollLeft = targetRect.left - containerRect.left + parent.scrollLeft - 100;
    
        parent.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        });
      }
    }
    
    isScrollable(el) {
      if (!el) return false;
    
      const style = window.getComputedStyle(el);
      const overflowY = style.overflowY;
      const overflowX = style.overflowX;
    
      const canScrollVertically = (overflowY === 'scroll' || overflowY === 'auto') && el.scrollHeight > el.clientHeight;
      const canScrollHorizontally = (overflowX === 'scroll' || overflowX === 'auto') && el.scrollWidth > el.clientWidth;
    
      return canScrollVertically || canScrollHorizontally;
    }

    // 初始化 MAPPY 搜索功能
    initMappySearch() {
      // 初始化搜索输入框和按钮的监听
      this.initBssSearchElements();
      // 等待 MAPPY 插件的搜索组出现
      this.waitForMappySearchGroup();
    }

    // 动态获取 id 为 bss-search-input 的元素
    getBssSearchInput() {
      const element = document.getElementById('bss-search-input');
      if (element) {
        console.log('找到 bss-search-input 元素:', element);
        return element;
      }
      return null;
    }

    // 动态获取 id 为 bss-search-btn 的元素
    getBssSearchBtn() {
      const element = document.getElementById('bss-search-btn');
      if (element) {
        console.log('找到 bss-search-btn 元素:', element);
        return element;
      }
      return null;
    }

    // 使用 MutationObserver 监听 DOM 变化，动态获取元素
    initBssSearchElements() {
      const observer = new MutationObserver((mutations) => {
        const inputElement = this.getBssSearchInput();
        const btnElement = this.getBssSearchBtn();
        
        if (inputElement && btnElement) {
          // 找到两个元素后，停止观察
          observer.disconnect();
          
          // 为 input 添加事件监听
          inputElement.addEventListener('input', () => {
            console.log('input 事件触发', inputElement.value);
          });
          
          // 为 button 添加事件监听（可选）
          btnElement.addEventListener('click', () => {
            console.log('button 点击事件触发', inputElement.value);
          });
        } else if (inputElement) {
          // 如果只找到 input，继续监听 button
          inputElement.addEventListener('input', () => {
            console.log('input 事件触发', inputElement.value);
          });
        }
      });

      // 开始观察整个文档的变化
      observer.observe(document.body, {
        childList: true,      // 监听子节点的添加和删除
        subtree: true         // 监听所有后代节点
      });

      // 立即尝试获取一次（如果元素已经存在）
      const inputElement = this.getBssSearchInput();
      const btnElement = this.getBssSearchBtn();
      
      // 如果两个元素都已存在，直接设置事件监听
      if (inputElement && btnElement) {
        observer.disconnect();
        inputElement.addEventListener('input', () => {
          console.log('input 事件触发', inputElement.value);
        });
        btnElement.addEventListener('click', () => {
          console.log('button 点击事件触发', inputElement.value);
        });
      }
    }

    // 等待 MAPPY 插件的 bss-wrapper-header 元素出现，然后插入下拉表单
    waitForMappySearchGroup() {
      // 先检查是否已经存在
      let searchGroup = document.querySelector('#bss-wrapper-header');
      
      if (searchGroup) {
        this.insertDropdownForm(searchGroup);
        return;
      }

      // 使用 MutationObserver 监听 DOM 变化
      const observer = new MutationObserver((mutations, obs) => {
        searchGroup = document.querySelector('#bss-wrapper-header');
        if (searchGroup) {
          this.insertDropdownForm(searchGroup);
          obs.disconnect(); // 找到后停止观察
        }
      });

      // 开始观察整个文档的变化
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      // 设置超时，避免无限等待
      setTimeout(() => {
        observer.disconnect();
      }, 30000); // 30秒后停止观察
    }

    // 等待 bss-suggest-results 有内容返回后再点击搜索按钮
    waitForSuggestResults(button) {
      if (!button) {
        console.warn('搜索按钮不存在');
        return;
      }

      // 检查15秒内是否能获取到 #bss-suggest-results 元素
      const startTime = Date.now();
      const timeout = 5000; // 15秒超时

      // 先检查是否已经有结果
      let suggestResults = document.querySelector('#bss-suggest-results');
      if (suggestResults && suggestResults.children.length > 0) {
        button.click();
        return;
      }

      // 使用 MutationObserver 监听结果容器
      const observer = new MutationObserver((mutations, obs) => {
        // 检查是否超时
        if (Date.now() - startTime > timeout) {
          console.warn('15秒内未获取到 #bss-suggest-results 元素，取消操作');
          obs.disconnect();
          // 移除下拉表单
          const dropdownForm = document.querySelector('.yg-custom-dropdown-form');
          if (dropdownForm) {
            dropdownForm.remove();
          }
          return;
        }

        suggestResults = document.querySelector('#bss-suggest-results');
        
        // 检查是否有内容（子元素或文本内容）
        if (suggestResults) {
          const hasContent = suggestResults.children.length > 0 || 
                           (suggestResults.textContent && suggestResults.textContent.trim().length > 0) ||
                           suggestResults.innerHTML.trim().length > 0;
          
          if (hasContent) {
            button.click();
            obs.disconnect(); // 找到后停止观察
          }
        }
      });

      // 开始观察
      // 先尝试找到已存在的元素
      suggestResults = document.querySelector('#bss-suggest-results');
      if (suggestResults) {
        observer.observe(suggestResults, {
          childList: true,
          subtree: true,
          characterData: true
        });
      } else {
        // 如果元素还不存在，观察整个文档
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      }

      // 设置超时，避免无限等待（15秒后取消操作）
      setTimeout(() => {
        observer.disconnect();
        const suggestResults = document.querySelector('#bss-suggest-results');
        if (!suggestResults) {
          console.warn('5秒内未获取到 #bss-suggest-results 元素，取消操作');
          // 移除下拉表单
          const dropdownForm = document.querySelector('.yg-custom-dropdown-form');
          if (dropdownForm) {
            dropdownForm.remove();
          }
        } else {
          button.click();
        }
      }, timeout);
    }

    // 在搜索组容器中插入下拉表单
    insertDropdownForm(container) {
      // 检查是否已经插入过，避免重复插入
      if (container.querySelector('.yg-custom-dropdown-form')) {
        return;
      }

      // 创建下拉表单容器
      const dropdownContainer = document.createElement('div');
      dropdownContainer.className = 'yg-custom-dropdown-form';

      // 创建下拉选择框
      const select = document.createElement('select');
      select.className = 'yg-location-select';
      const optionElement = document.createElement('option');
      optionElement.value = '';
      optionElement.textContent = 'Select your country';
      optionElement.selected = true;
      optionElement.disabled = true;
      select.appendChild(optionElement);
      // 添加选项（示例数据，你可以根据实际需求修改）
      const countryList = this.querySelector('.yg-country-list-template').content.querySelectorAll('.yg-country-item');

      countryList.forEach(item => {
        const optionElement = document.createElement('option');
        optionElement.value = item.getAttribute('data-country');
        optionElement.textContent = item.getAttribute('data-country');
        select.appendChild(optionElement);
      });

      dropdownContainer.appendChild(select);

      // 创建清除图标 SVG
      const clearIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      clearIcon.setAttribute('width', '24');
      clearIcon.setAttribute('height', '24');
      clearIcon.setAttribute('viewBox', '0 0 24 24');
      clearIcon.setAttribute('fill', 'none');
      clearIcon.setAttribute('class', 'yg-clear-icon'); // SVG 元素需要使用 setAttribute 设置 class
      clearIcon.style.display = 'none'; // 初始隐藏
      clearIcon.style.cursor = 'pointer'; // 添加鼠标指针样式
      
      const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      g.setAttribute('clip-path', 'url(#prefix__clip0_19_75589)');
      g.setAttribute('stroke', 'currentColor');
      g.setAttribute('stroke-width', '1.5');
      g.setAttribute('stroke-linecap', 'round');
      
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M7 7l9.9 9.9M16.9 7L7 16.9');
      g.appendChild(path);
      
      const defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
      const clipPath = document.createElementNS('http://www.w3.org/2000/svg', 'clipPath');
      clipPath.setAttribute('id', 'prefix__clip0_19_75589');
      const clipPathRect = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      clipPathRect.setAttribute('fill', '#fff');
      clipPathRect.setAttribute('d', 'M0 0h24v24H0z');
      clipPath.appendChild(clipPathRect);
      defs.appendChild(clipPath);
      
      clearIcon.appendChild(g);
      clearIcon.appendChild(defs);
      
      // 为清除图标添加点击事件
      clearIcon.addEventListener('click', (e) => {
        e.stopPropagation(); // 阻止事件冒泡
        // 清空 select 选择内容
        select.value = '';
        // 触发 select 的 change 事件，确保相关逻辑执行（包括过滤商店列表）
        select.dispatchEvent(new Event('change', {
          bubbles: true,
          cancelable: true
        }));
        // 触发 find-my-location-button-on-map 的点击事件
        const findLocationButton = document.querySelector('.find-my-location-button-on-map');
        if (findLocationButton) {
          findLocationButton.click();
        }

        this.classList.remove('yg-filter-by-country');
      });
      
      dropdownContainer.appendChild(clearIcon);

      // 监听下拉选择变化，自动填充到 MAPPY 输入框
      select.addEventListener('change', (e) => {
        const selectedValue = e.target.value;
        
        // 根据是否有选择内容来控制清除图标的显示/隐藏
        if (selectedValue) {
          clearIcon.style.display = 'block';
        } else {
          clearIcon.style.display = 'none';
        }
        
        // 根据选择的国家过滤显示对应的 yg-shop-item
        this.filterShopItemsByCountry(selectedValue);
        
        if (selectedValue) {
          // 查找 MAPPY 的输入框
          const mappyInput = container.querySelector('input[type="text"]') || 
                            container.querySelector('input[placeholder*="location"]') ||
                            container.querySelector('input[placeholder*="位置"]') ||
                            document.querySelector('#bss-wrapper-header input');
          const button = container.querySelector('#bss-search-btn');
          if (mappyInput) {
            // 设置值并触发事件
            mappyInput.value = selectedValue;
            
            // 触发多个事件以确保插件能识别
            const events = ['input', 'keyup', 'change', 'focus'];
            events.forEach(eventType => {
              console.log('触发事件', eventType);
              
              mappyInput.dispatchEvent(new Event(eventType, {
                bubbles: true,
                cancelable: true
              }));
            });

            // 延迟触发 focus，模拟用户交互
            setTimeout(() => {
              mappyInput.focus();
              mappyInput.dispatchEvent(new Event('input', {
                bubbles: true,
                cancelable: true
              }));
              
              // 等待 bss-suggest-results 有内容后再点击按钮
              this.waitForSuggestResults(button);
            }, 100);
          }
        }
      });
      
      container.appendChild(dropdownContainer);
    }

    targetCountryCount(number,country) {
      this.selectCountryTitle.querySelector('.yg-shop-count').innerHTML = number;
      this.selectCountryTitle.querySelector('.yg-country-name').innerHTML = country;
    }

    // 根据选择的国家过滤显示对应的 yg-shop-item
    filterShopItemsByCountry(country) {
      this.classList.add('yg-filter-by-country');
      // 使用已有的 shopList（在构造函数中已获取）
      const shopItems = this.shopList.length > 0 ? this.shopList : this.querySelectorAll('.yg-shop-item');
      let number = 0;
      shopItems.forEach(item => {
        if (item.getAttribute('data-country') == country) {
          item.classList.add('yg-country-item-active');
          number++;
        } else {
          item.classList.remove('yg-country-item-active');
        }
      });
      
      // 更新计数
      this.targetCountryCount(number,country);
    }
  }
  if (!window.customElements.get('yg-shop-list')) {
      window.customElements.define('yg-shop-list', YGShopList)
  }

  class YG3dSearch extends HTMLElement {
      constructor() {
          super()

          this.titleList = this.querySelectorAll('.yg-filter-item[data-title]');
          this.typeList = this.querySelectorAll('.yg-filter-item[data-type]');
          this.contentList = this.querySelectorAll('.yg-3d-content[data-title]')
          this.itemList = this.querySelectorAll('.yg-3d-item');
          this.buttonList = this.querySelectorAll('.yg-3d-content-more');
      }
      connectedCallback() {
        this.buttonList.forEach((btn) => {
          btn.addEventListener('click', () => this.targetContent('current', btn))
        })

        this.titleList.forEach((title) => {
          title.addEventListener('click', () => this.targetTitle(title))
        })

        this.typeList.forEach((type) => {
          type.addEventListener('click', () => this.targetType(type))

          let typeItems = this.querySelectorAll(`.yg-3d-item[data-type=${type.getAttribute('data-type')}]`)
          type.querySelector('.yg-count').innerHTML = `(${typeItems.length})`

        })
      }

      targetTitle(title) {
        if (title.classList.contains('active') ) return
        
        this.titleList.forEach((item) => {
          item.classList.remove('active')
        })
        title.classList.add('active')

        if(title.getAttribute('data-title') == 'all') {
          let activeType = this.querySelectorAll('.yg-filter-item[data-type].active')

          activeType.length > 0 || this.targetContent('close')
          this.contentList.forEach((el) => {
            el.classList.remove('hide')
          })
        }else{
          this.contentList.forEach((el) => {
            if (el.getAttribute('data-title') == title.getAttribute('data-title')) {
              el.classList.remove('hide')
            }else {
              el.classList.add('hide')
            }
          })
          
          this.targetContent('open')
        }

        this.typeList.forEach((type) => {

          let typeItems = this.querySelectorAll(`.yg-3d-content:not(.hide) .yg-3d-item[data-type=${type.getAttribute('data-type')}]`)
          type.querySelector('.yg-count').innerHTML = `(${typeItems.length})`

        })
      }

      targetType(type) {
        if (type.classList.contains('active')) {
          type.classList.remove('active')
        } else {
          type.classList.add('active')
        }

        let activeType = this.querySelectorAll('.yg-filter-item[data-type].active')
        let isRemove = activeType.length > 0 ? false : true


        this.itemList.forEach((item) => {
          if (isRemove) {
            item.classList.remove('hide')

          } else {
            item.classList.add('hide')
            activeType.forEach((t) => {
              if (item.getAttribute('data-type') == t.getAttribute('data-type')) {
                item.classList.remove('hide')
              }
            })

          }
        })

        if (isRemove) {
          this.buttonList.forEach((el) => {
            el.classList.remove('hide')
          })
          
          this.targetContent('close')
        }else {
          this.buttonList.forEach((el) => {
            el.classList.add('hide')
          })
          this.targetContent('open')
        }
      }

      targetContent(type, item) {
        if (type == 'open') {
          this.contentList.forEach((el) => {
            el.classList.add('active')
          })

          this.buttonList.forEach((el) => {
            el.innerHTML = 'View less'
          })

          return
        }

        if (type == 'close') {
          this.contentList.forEach((el) => {
            el.classList.remove('active')
          })

          this.buttonList.forEach((el) => {
            el.innerHTML = 'View All'
          })

          return
        }

        if (type == 'current' && item) {
          if (item.classList.contains('active')) {
            item.classList.remove('active')
            item.closest('.yg-3d-content').classList.remove('active')
            item.innerHTML = 'View All'
          } else {
            item.classList.add('active')
            item.closest('.yg-3d-content').classList.add('active')
            item.innerHTML = 'View less'
          }
        }
      }
  }
  if (!window.customElements.get('yg-3d-search')) {
      window.customElements.define('yg-3d-search', YG3dSearch)
  }

  (function() {
    // 收集所有 yg-faq-data script 标签中的 FAQ 数据
    const faqDataScripts = document.querySelectorAll('script.yg-faq-data[type="application/json"]');
    const allQuestions = [];
    
    faqDataScripts.forEach(function(script) {
      try {
        const textContent = script.textContent.trim();
        if (textContent) {
          const questions = JSON.parse(textContent);
          if (Array.isArray(questions)) {
            allQuestions.push(...questions);
          }
        }
      } catch (e) {
        console.warn('Failed to parse FAQ data:', e, script);
      }
    });
    
    
    // 如果有 FAQ 数据，生成统一的结构化数据
    if (allQuestions.length > 0) {
      const faqSchema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": allQuestions
      };
      
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(faqSchema);
      document.head.appendChild(script);
    }
  })();
})  

